<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-50"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[1100px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]">รายการร้องขอทรัพยากร</span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div class="max-h-[642px] flex flex-col gap-[30px] p-[20px] pt-[12px] overflow-auto">
            <div class="w-full flex flex-col items-center gap-[20px]">
              <div class="flex items-center justify-between self-stretch flex-wrap gap-[16px]">
                <div class="PC_H2-SB text-[1F1D1F]">รายการร้องขอทรัพยากร</div>
                <div
                  v-if="auth.hasRole([ROLES.staff])"
                  class="flex items-center gap-[10px]"
                >
                  <ButtonComponent
                    :label="'ประวัติ'"
                    :bClass="'btn_shadow--32 min-w-[67px]'"
                    @clicked="requestHistory"
                  />
                  <ButtonComponent
                    :icon="'HeartIcon'"
                    :label="'ร้องขอทรัพยากร'"
                    :disabled="shelter.status == 2"
                    :bClass="'btn_shadow--12s h-[42px] min-w-[142px]'"
                    @clicked="requestResources"
                  />
                </div>
              </div>
              <div class="w-full h-[1px] bg-[#DFDCDD]"></div>
              <div
                class="flex items-start justify-between gap-[10px] self-stretch flex-wrap md:flex-nowrap"
              >
                <div class="w-full">
                  <!-- search -->
                  <SearchBox
                    :placeholder="'ค้นหา ชื่อทรัพยากร'"
                    v-model="filter.search"
                    @update:modelValue="
                      () => {
                        (filter.page = ''), debouncedFetch();
                      }
                    "
                  />
                  <!-- search -->
                </div>
                <div
                  class="flex items-center gap-[10px] flex-wrap sm:flex-nowrap"
                >
                  <SelectBox
                    :searchable="true"
                    :selectContainerClass="'w-full sm:min-w-[148px] sm:max-w-[148px]'"
                    valueKey="id"
                    :options="resourceTypeOption"
                    v-model="filter.category_id"
                    :placeholder="'แสดงทุกประเภท'"
                    @change="
                      (res) => {
                        filter.category_id = res.id;
                        filter.page = '';
                        getData();
                      }
                    "
                  />
                  <SelectBox
                    :searchable="true"
                    :selectContainerClass="'w-full sm:min-w-[168px] sm:max-w-[168px]'"
                    valueKey="id"
                    :options="resourceClassifierOption"
                    v-model="filter.unit_id"
                    :placeholder="'แสดงทุกลักษณนาม'"
                    @change="
                      (res) => {
                        filter.unit_id = res.id;
                        filter.page = '';
                        getData();
                      }
                    "
                  />
                  <SelectBox2
                    :selectContainerClass="'w-full sm:min-w-[164px] sm:max-w-[164px]'"
                    :inputId="'filter33'"
                    :keyValue="'action'"
                    :keyName="'name'"
                    :options="Selector.sortOption1"
                    :value="filter.sort"
                    :placeholder="'แสดงรายการล่าสุด'"
                    :defaultVal="''"
                    @update:modelValue="
                      (res) => {
                        filter.sort = res;
                        filter.page = '';
                        getData();
                      }
                    "
                  />
                </div>
              </div>
            </div>
            <div>
              <!-- filter bar -->
              <div class="overflow-scroll">
                <div class="min-w-[620px] flex items-center gap-[4px]">
                  <div
                    v-for="row in allProductGroup"
                    :key="row.id"
                    class="filterBar"
                    :class="{
                      active: String(filter.group_id ?? '') === String(row.id),
                    }"
                    @click="
                      () => {
                        const isSame =
                          String(filter.group_id ?? '') === String(row.id);
                        if (!isSame) {
                          filter.group_id = row.id;
                          filter.page = '';
                          getData();
                        }
                      }
                    "
                  >
                    <span class="PC_Body2-R">{{ row.name }}</span>
                  </div>
                </div>
              </div>
              <!-- filter bar -->
              <div
                class="min-h-[580px] sm:min-h-[0px] h-[342px] p-[10px] rounded-[6px] border-[1px] border-solid border-[#B7B2B5] bg-[#fff] overflow-auto"
              >
                <div
                  class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[6px]"
                >
                  <ResourcesCard
                    v-for="(pub, index) in productRequestList"
                    :key="index"
                    :item="pub"
                    :permission="false"
                    @cancel="cancel"
                    @edit="edit"
                    @update="update"
                    @transfer="transfer"
                  />
                </div>
                <div
                  v-if="productRequestList.length <= 0"
                  class="w-full flex items-center justify-center py-[20px] PC_Body1-R text-[#7C7379]"
                >
                  ขออภัย ไม่พบรายการที่ตรงกับการค้นหา
                </div>
              </div>
            </div>
            <!-- pagination for modal -->
            <PaginationComponent
              :perPageId="'perpagemodal'"
              :items="pagination"
              @selectedPage="handlePage"
            />
            <!-- pagination for modal -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Selector } from "@/components/Utilities/javascripts/constants";
import { useProductStore } from "@/pinia/product";
import { useAuthStore } from "@/pinia/authStore";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";
import ResourcesCard from "@/components/Cards/ResourcesCard.vue";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const router = useRouter();
const route = useRoute();
const productStore = useProductStore();
const {
  allProductType,
  allProductClassifier,
  productRequestList,
  allProductGroup,
} = storeToRefs(productStore);
const auth = useAuthStore();

const resourceTypeOption = computed(() => {
  return [
    {
      id: "",
      name: "แสดงทุกประเภท",
    },
    {
      id: "-1",
      name: "ไม่มีประเภท",
    },
    ...allProductType.value,
  ];
});

const resourceClassifierOption = computed(() => {
  return [
    {
      id: "",
      name: "แสดงทุกลักษณนาม",
    },
    {
      id: "-1",
      name: "ไม่มีลักษณนาม",
    },
    ...allProductClassifier.value,
  ];
});

const defaultFilter = {
  shelter_id: "",
  paginate: 8,
  page: "",
  search: "",
  category_id: "",
  unit_id: "",
  sort: "desc",
  group_id: 1,
};
const filter = ref({ ...defaultFilter });
const pagination = ref(null);
const shelter = ref({});
const modalIsOpened = ref(false);

const emit = defineEmits([
  "status",
  "history",
  "cancel",
  "edit",
  "update",
  "transfer",
]);

const openModal = async (data) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  shelter.value = data;
  filter.value = { ...defaultFilter };
  filter.value.shelter_id = shelter.value.id;
  await getData();
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const getData = async () => {
  await productStore
    .getProductRequest(filter.value)
    .then((response) => {
      if (response.status == 200) {
        pagination.value = response.data.data;
      }
    })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};

const debouncedFetch = debounce(getData, 300);

const updateModal = () => {
  filter.value.page = "";
  getData();
};

const requestHistory = () => {
  emit("history");
};

const requestResources = () => {
  router.push(
    `/shelter/${route.meta.decodedParams?.shelterId}/resources/request-resources`
  );
  closeModal();
};

const cancel = (data) => {
  const message = "ต้องการยุติคำขอหรือไม่";
  emit(
    "status",
    message,
    "warning",
    ["ยกเลิก", "ยุติคำขอ"],
    data,
    "cancelRequestResource"
  );
};

const edit = (data) => {
  emit("edit", data);
};

const update = (data) => {
  emit("update", data);
};

const transfer = (data) => {
  emit("transfer", data);
};

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

defineExpose({ openModal, updateModal });
</script>

<style lang="scss" scoped>
</style>